const register = {
  loginCredentials: "Credenciais de login", // translated
  companyInformation: "Informações da Empresa", // translated
  contactDetails: "Detalhes do contato", // translated
  businessName: "Nome da empresa", // translated
  businessAddress: "Endereço profissional", // translated
  registrationCode: "Código de Registo", // translated
  websiteUrl: "URL do site", // translated
  mobilePhone: "Celular", // translated
  regionStateProvince: "Região/Estado/Província", // translated
  legalTitle: "Título legal", // translated
  city: "Cidade", // translated
  postalCode: "Código postal", // translated
  registrationSuccess: "Registro bem sucedido.", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome: "Aguarde alguns instantes e você será redirecionado para a página inicial.", // translated
};

export default register;
